var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAppointments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4708 55.6197C50.0577 55.23 66.6228 55.1344 83.169 55.3312C84.3108 55.1115 85.5556 55.4516 85.9597 56.0954C86.0438 56.2425 86.0845 56.3972 86.079 56.5519V64.3748C86.2309 64.7913 85.9923 65.2211 85.4471 65.5134C84.9074 65.7962 84.1562 65.9108 83.4375 65.8191C67.8541 66.1553 52.2517 65.9738 36.7063 65.2765C35.4696 65.309 34.2546 65.0721 33.3189 64.6136C32.8823 64.2793 32.5921 63.8896 32.4782 63.477V63.1713C31.9521 61.4405 31.7134 59.6849 31.7595 57.9274V56.8748L33.4708 55.6197Z",
    fill: "#F4F4F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4708 76.013C50.0577 75.6233 66.6228 75.5278 83.169 75.7245C84.3108 75.5048 85.5556 75.8449 85.9597 76.4887C86.0438 76.6358 86.0845 76.7905 86.079 76.9452V84.7682C86.2309 85.1846 85.9923 85.6144 85.4471 85.9067C84.9074 86.1895 84.1562 86.3041 83.4375 86.2124C67.8541 86.5486 52.2517 86.3671 36.7063 85.6698C35.4696 85.7023 34.2546 85.4654 33.3189 85.0069C32.8823 84.6726 32.5921 84.2829 32.4782 83.8703V83.5646C31.9521 81.8338 31.7134 80.0782 31.7595 78.3207V77.2681L33.4708 76.013Z",
    fill: "#F4F4F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9406 65.9436L87.36 52.1091C87.36 52.1091 28.9817 51.0732 30.5496 52.1091C32.1174 53.145 30.5496 66.8792 30.5496 66.8792L86.9406 65.9436Z",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3487 31.6785C71.9248 31.2481 76.4949 31.1426 81.0598 31.3599C81.3748 31.1172 81.7182 31.4928 81.8297 32.2039C81.8529 32.3664 81.8641 32.5373 81.8626 32.7082V41.3491C81.9045 41.8091 81.8387 42.2838 81.6883 42.6067C81.5394 42.919 81.3321 43.0456 81.1338 42.9443C76.8346 43.3157 72.5301 43.1152 68.2413 42.345C67.9001 42.3809 67.5649 42.1192 67.3068 41.6128C67.1863 41.2435 67.1062 40.8131 67.0748 40.3573V40.0197C66.9297 38.108 66.8638 36.1688 66.8765 34.2275V33.0648L67.3487 31.6785Z",
    fill: "#F4F4F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9406 90.0346L87.36 76.2002C87.36 76.2002 28.9817 75.1642 30.5496 76.2002C32.1174 77.2361 30.5496 90.9703 30.5496 90.9703L86.9406 90.0346Z",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4957 23.661C25.4957 23.661 24.3443 89.3015 25.5511 101.57C26.7579 113.838 26.0454 111.247 39.6767 111.922C53.3081 112.596 88.3415 112.596 90.8521 111.078C93.3626 109.56 93.9608 100.285 93.8407 92.5294C93.7206 84.7739 95.8268 44.7608 94.6316 35.9922C89.2915 31.2299 80.7377 24.3317 75.6833 19.1758C59.1822 19.85 25.5519 19.793 25.5519 19.793C25.5519 19.793 25.5372 19.5878 25.4957 23.661Z",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3122 19.3037H41.0855L37.5086 20.7345L36.4355 23.5959L40.7278 31.465L50.3853 28.2459L49.3122 19.3037Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9395 19.6616H49.3123",
    stroke: "#70758F",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2188 29.0225V19.365L94.2579 35.6448C90.6708 36.0127 82.724 36.5278 79.6336 35.6448C76.5432 34.7618 75.4027 30.862 75.2188 29.0225Z",
    fill: "#F4F4F5",
    stroke: "#70758F",
    strokeWidth: 1.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3818 106.283C34.3818 106.283 37.825 99.5894 43.3703 100.26C47.4292 100.75 49.5693 104.818 49.5693 104.818L57.008 102.539",
    stroke: "#70758F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAppointments);
export default __webpack_public_path__ + "static/media/no-appointments.218e7d155af7def642f9b3435c030d3c.svg";
export { ForwardRef as ReactComponent };